import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useStore } from '../../../contexts/store-provider';
import { AddTeplarInitialState } from '../../../core/initialState';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import {
  IAddTeplar,
  IUpdateTeplar,
} from '../../../models/forms/IAddUpdateTeplar';
import { IFormModalProps } from '../../../models/forms/IForm';
import { formatMessage } from '../../../translations/format-message';
import AddTeplarPrintForm from '../forms/add-edit-teplar-print-form';
import UpdateTeplarPrintForm from '../forms/update-teplar-print-form';

const ImportHolidays = (props: IFormModalProps) => {
  const initialValues: IAddTeplar = AddTeplarInitialState;
  const { teplarPrintStore } = useStore();
  const {
    AddTeplarService,
    fileUploadState,
    resetFileUploadState,
    teplarDetails,
    dupliacteRecords,
    GetDetailsTeplarByIdService,
    UpdateTeplarService,
    updateTeplarState,
  } = teplarPrintStore;

  useEffect(() => {
    if (fileUploadState.success) {
      onModalClosed();
    }
  }, [fileUploadState.success]);

  useEffect(() => {
    if (fileUploadState.error) {
      toast.error(formatMessage(fileUploadState.error));
    }
  }, [fileUploadState.error]);

  useEffect(() => {
    if (updateTeplarState.success) {
      toast.success(formatMessage('updated_success'));
      onModalClosed();
    }
  }, [updateTeplarState.success]);

  useEffect(() => {
    if (updateTeplarState.error) {
      toast.error(formatMessage(updateTeplarState.error));
      resetFileUploadState();
    }
  }, [updateTeplarState.error]);

  useEffect(() => {
    if (props.id > 0) {
      GetDetailsTeplarByIdService(
        Number(getTenantIdFromLocalStorage()),
        props.id
      );
    }
  }, [props.id]);

  const onUpdateSubmitForm = (values: IUpdateTeplar) => {
    UpdateTeplarService({
      ...values,
      Layout: values.Layout || 0,
      Width: values.Width || 0,
      Id: props.id,
      Items: values.Items.join(','),
      TenantId: Number(getTenantIdFromLocalStorage()),
    });
  };

  const onAddSubmitForm = (values: IAddTeplar) => {
    AddTeplarService(Number(getTenantIdFromLocalStorage()), values.formFile);
  };

  const onModalClosed = () => {
    props.modalClosed();
  };

  return (
    <React.Fragment>
      {props.id > 0 ? (
        <UpdateTeplarPrintForm
          id={props.id}
          onModalClosed={onModalClosed}
          initialValues={teplarDetails}
          isLoading={false}
          submitHandler={onUpdateSubmitForm}
        />
      ) : (
        <AddTeplarPrintForm
          initialValues={initialValues}
          id={props.id}
          submitHandler={onAddSubmitForm}
          onModalClosed={onModalClosed}
          isLoading={fileUploadState.inProgress}
          duplicateRecords={dupliacteRecords}
        />
      )}
    </React.Fragment>
  );
};

export default observer(ImportHolidays);
